(function() {
    'use strict';

    var conferencesApp = angular.module('conferencesApp', [
        'ngResource', 'ngMessages', 'ngSanitize', 'ngFileUpload', 'angularMoment', 'ui.router', 'ui.bootstrap', 'worldskills.utils'
    ]);

    conferencesApp.constant('CONFERENCES_APP_CODE', 2500);
    conferencesApp.constant('RESOURCES_APP_CODE', 1000);
    conferencesApp.constant('WS_ENTITY_PUBLIC_RESOURCES_ID', 78);
    conferencesApp.constant('RESOURCES_TYPE_CONFERENCE_UPLOADS', 31);
    conferencesApp.constant('RESOURCES_STORAGE_TYPE_LOCAL_FILE', 1);

    conferencesApp.config(function ($stateProvider, $urlRouterProvider) {

        $urlRouterProvider.otherwise(function ($injector, $location) {
            // check for existing redirect
            var $state = $injector.get('$state');
            var redirectToState = sessionStorage.getItem('redirect_to_state');
            var redirectToParams = sessionStorage.getItem('redirect_to_params');
            sessionStorage.removeItem('redirect_to_state');
            sessionStorage.removeItem('redirect_to_params');
            if (redirectToState) {
                if (redirectToParams) {
                    redirectToParams = angular.fromJson(redirectToParams);
                } else {
                    redirectToParams = {};
                }
                $state.go(redirectToState, redirectToParams);
            } else {
                $state.go('admin_conferences.list');
            }
        });

        $stateProvider.state('admin_conferences', {
            url: '/admin',
            templateUrl: 'views/admin-conferences.html',
            controller: 'AdminConferencesCtrl',
            abstract: true
        }).state('admin_conferences.list', {
            url: '',
            templateUrl: 'views/admin-conferences-list.html',
            controller: 'AdminConferencesListCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference', {
            url: '/{conferenceId}',
            templateUrl: 'views/admin-conference.html',
            controller: 'AdminConferenceCtrl',
            abstract: true
        }).state('admin_conferences.conference.detail', {
            url: '',
            templateUrl: 'views/admin-conference-detail.html',
            controller: 'AdminConferenceDetailCtrl',
            abstract: true
        }).state('admin_conferences.conference.detail.sessions', {
            url: '/sessions',
            templateUrl: 'views/admin-conference-sessions.html',
            controller: 'AdminConferenceSessionsCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference.detail.speakers', {
            url: '/speakers',
            templateUrl: 'views/admin-conference-speakers.html',
            controller: 'AdminConferenceSpeakersCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference.session_create', {
            url: '/sessions/create',
            templateUrl: 'views/admin-conference-session-create.html',
            controller: 'AdminConferenceSessionCreateCtrl',
            abstract: true
        }).state('admin_conferences.conference.session_create.form', {
            url: '',
            templateUrl: 'views/admin-conference-session-form.html',
            controller: 'AdminConferenceSessionFormCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference.session', {
            url: '/sessions/{sessionId}',
            templateUrl: 'views/admin-conference-session.html',
            controller: 'AdminConferenceSessionCtrl',
            abstract: true
        }).state('admin_conferences.conference.session.form', {
            url: '',
            templateUrl: 'views/admin-conference-session-form.html',
            controller: 'AdminConferenceSessionFormCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference.session.speakers', {
            url: '/speakers',
            templateUrl: 'views/admin-conference-session-speakers.html',
            controller: 'AdminConferenceSessionSpeakersCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference.speaker_create', {
            url: '/speakers/create?sessionId',
            templateUrl: 'views/admin-conference-speaker.html',
            controller: 'AdminConferenceSpeakerCreateCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference.speaker', {
            url: '/speakers/{speakerId}',
            templateUrl: 'views/admin-conference-speaker.html',
            controller: 'AdminConferenceSpeakerCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        }).state('admin_conferences.conference.session.files', {
            url: '/files',
            templateUrl: 'views/admin-conference-session-files.html',
            controller: 'AdminConferenceSessionFilesCtrl',
            data: {
                requireLoggedIn: true,
                requiredRoles: [
                    {code: 2500, role: 'Admin'},
                    {code: 2500, role: 'EditConferences'}
                ]
            }
        });

    });

    conferencesApp.config(function ($uiViewScrollProvider) {
        $uiViewScrollProvider.useAnchorScroll();
    });

})();
